<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Certificate Signing Request</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <span class="fw-bold">
                Certificate:
            </span>
            {{ modalData.commonName }}
            <br><br>
            <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="fw-bold">CSR:</span>
                <button type="button" @click="onCopyCSR" class="btn btn-secondary btn-sm" data-bs-toggle="tooltip"
                    data-bs-placement="left" title="Copy CSR">
                    <i class="fa fa-solid fa-copy" />
                </button>
            </div>
            <div class="form-control">
                <CodemirrorEditor :editorId="`csr-${Math.random()}`" v-model="csrJson" mode="json"
                    :refreshOn="true" :disabled="true" :readOnly="true" :performLint="false"></CodemirrorEditor>
            </div>
        </div>
        <div class="card-footer justify-content-end d-flex align-items-center gap-3">
            <span class="text-danger" v-if="error">{{ error }}</span>
            <button class="btn btn-primary" :disabled="downloading" @click="handleDownload()">
                <div v-if="downloading" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    Download
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import CodemirrorEditor from "../../components/CodemirrorEditor.vue";
export default {
    components: { CodemirrorEditor },
    data() {
        return {
            error: "",
            csr: null,
            csrJson: null,
            downloading: false,
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "AcknowledgeDenyWarnings",
    methods: {
        ...mapActions("aut", {
            getCSR: "getCertificateCSR",
        }),
        handleDownload() {
            if (!this.csr || !this.csr.csrs.length) {
                this.error = "CSR not found"
                return;
            }
            this.downloading = true;
            this.csr.csrs.forEach(csrEntry => {
                const filename = `${this.modalData.commonName}(${csrEntry.keyAlgorithm}).pem`;
                const blob = new Blob([csrEntry.csr], { type: "application/x-pem-file" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
            this.downloading = false;
        },
        async onCopyCSR() {
            if (!this.csrJson) return;

            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(this.csrJson);
                } else {
                    // Fallback for older browsers
                    const input = document.createElement('textarea');
                    input.style.position = 'absolute';
                    input.style.left = '-9999px';
                    input.value = this.csrJson;
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                }

                this.$store.dispatch('addToast', {
                    message: "CSR copied to clipboard.",
                    type: "info"
                });
            } catch (err) {
                this.$store.dispatch('addToast', {
                    message: "Failed to copy CSR.",
                    type: "error"
                });
            }
        }

    },
    async beforeMount() {
        await this.getCSR(this.modalData.commonName).then((response) => {
            this.csr = response.data;
            this.csrJson = JSON.stringify(this.csr, null, 2);
        }).catch((error) => {
            let err = null;
            if (error.response.data.error) err = error.response.data.error;
            else err = error.message;
            let toastOptions = {
                message: err || "Something went wrong while fetching CSR. Please contact support.",
                type: "error"
            }
            this.$store.dispatch("addToast", toastOptions);
        })
    }
};
</script>

<style></style>